"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var _classnames = _interopRequireDefault(require("classnames"));
var _Mobile = _interopRequireDefault(require("./components/Mobile"));
var _Svg = _interopRequireDefault(require("./components/Svg"));
var _Jump = _interopRequireDefault(require("./components/Jump"));
var _index = require("../../common/utils/index");
var _formatVodData2 = require("../../utils/formatVodData");
var _getDataFormCid = require("./getDataFormCid");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function Tabs(props) {
  var _configuration$;
  let _ref = props || {},
    _ref$configuration = _ref.configuration,
    configuration = _ref$configuration === void 0 ? [] : _ref$configuration,
    children = _ref.children,
    _ref$isFix = _ref.isFix,
    isFix = _ref$isFix === void 0 ? false : _ref$isFix,
    domains = _ref.domains;
  // 增加 tab 绑定索引
  configuration = configuration.map((item, index) => _objectSpread(_objectSpread({}, item || {}), {}, {
    bindingNum: `${index}`
  }));
  const _useState = (0, _react.useState)(((_configuration$ = configuration[0]) === null || _configuration$ === void 0 ? void 0 : _configuration$.cid) || ''),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    currentCid = _useState2[0],
    setCurrentCid = _useState2[1];
  const _useState3 = (0, _react.useState)(0),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    checked = _useState4[0],
    setChecked = _useState4[1];
  const _useState5 = (0, _react.useState)(0),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    tempSaveParentIndex = _useState6[0],
    setTempSaveParentIndex = _useState6[1];
  const _useState7 = (0, _react.useState)(true),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    flexChild = _useState8[0],
    setFlexChild = _useState8[1];
  const _ref2 = (0, _react.useState)(configuration),
    _ref3 = (0, _slicedToArray2.default)(_ref2, 1),
    _ref3$ = _ref3[0],
    arr = _ref3$ === void 0 ? [] : _ref3$;
  // 收集所有tab面板数据
  const multipleData = configuration.map(item => _objectSpread({}, item.pane || {}));
  const _useState9 = (0, _react.useState)(multipleData),
    _useState0 = (0, _slicedToArray2.default)(_useState9, 2),
    childPane = _useState0[0],
    setChildPane = _useState0[1];
  const _ref4 = childPane || {},
    _ref4$simpleData = _ref4.simpleData,
    simpleData = _ref4$simpleData === void 0 ? [] : _ref4$simpleData,
    _ref4$iconsDesc = _ref4.iconsDesc,
    iconsDesc = _ref4$iconsDesc === void 0 ? [] : _ref4$iconsDesc;
  const panes = {
    status: true,
    val: []
  };
  const collectPane = (val, parentNum) => {
    if (!val) return true;
    val.forEach(item => {
      const _ref5 = item || {},
        render = _ref5.render,
        bindingNum = _ref5.bindingNum,
        pane = _ref5.pane,
        href = _ref5.href,
        c = _ref5.children;
      if (!item.parentIndex) {
        item.parentIndex = parentNum;
      }
      render && panes.val.push({
        render,
        bindingNum,
        href
      });
      const _ref6 = pane || {},
        simpleData = _ref6.simpleData,
        iconsDesc = _ref6.iconsDesc;
      if (simpleData) {
        collectPane(simpleData, bindingNum);
      }
      // if (simpleDesc) {
      //   collectPane(simpleDesc, bindingNum);
      // }
      if (iconsDesc) {
        collectPane(iconsDesc, bindingNum);
      }
      if (typeof c === 'object') {
        collectPane(c, bindingNum);
      }
    });
  };
  if (panes.status) {
    collectPane(configuration);
    panes.status = false;
  }
  const _useState1 = (0, _react.useState)(false),
    _useState10 = (0, _slicedToArray2.default)(_useState1, 2),
    showLeft = _useState10[0],
    setShowLeft = _useState10[1];
  const _useState11 = (0, _react.useState)(false),
    _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
    showRight = _useState12[0],
    setShowRight = _useState12[1];
  const _useState13 = (0, _react.useState)(false),
    _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
    svgStatus = _useState14[0],
    setSvgStatus = _useState14[1];
  const handleDome = (0, _react.useRef)();
  const handleDomePane = (0, _react.useRef)();
  const barAnimated = (0, _react.useRef)();
  // 改变左侧控制台
  const changeActionLeft = (0, _react.useCallback)(status => {
    setShowLeft(status);
  }, [showLeft]);
  // 改变右侧操作控制台
  const changeActionRight = (0, _react.useCallback)((val, status) => {
    if (val >= 0) {
      setShowRight(status);
    }
  }, [showRight]);
  const checkedStatus = (0, _react.useCallback)(record => {
    var _getDomeChild$getBoun, _getDomeChild$getBoun2;
    const _ref7 = record || {},
      hover = _ref7.hover,
      val = _ref7.val,
      _ref7$pane = _ref7.pane,
      pane = _ref7$pane === void 0 ? {} : _ref7$pane;
    if (!hover) {
      setChecked(val);
    }
    // setSvgStatus(val);
    pane && setChildPane(pane);
    // getBoundingClientRect
    const getContainerDome = handleDome.current;
    const getHandleDomePane = handleDomePane.current;
    const getDome = handleDome.current.childNodes[val];
    // 或者tab文本节点
    const getDomeChild2 = getDome.childNodes[0];
    const getDomeChild = getDomeChild2 === null || getDomeChild2 === void 0 ? void 0 : getDomeChild2.childNodes[0];
    const containerCountWidth = getContainerDome.scrollWidth || 0;
    const containerHtmlElementClientLeft = getContainerDome === null || getContainerDome === void 0 ? void 0 : getContainerDome.getBoundingClientRect().left;
    const containerHtmlElementClientWidth = getContainerDome === null || getContainerDome === void 0 ? void 0 : getContainerDome.getBoundingClientRect().width;
    const htmlElementClientLeft = getDome === null || getDome === void 0 ? void 0 : getDome.getBoundingClientRect().left;
    const htmlElementClientWidth = getDome === null || getDome === void 0 ? void 0 : getDome.getBoundingClientRect().width;
    const getDomeChildViewPortL = getDomeChild === null || getDomeChild === void 0 ? void 0 : (_getDomeChild$getBoun = getDomeChild.getBoundingClientRect) === null || _getDomeChild$getBoun === void 0 ? void 0 : (_getDomeChild$getBoun2 = _getDomeChild$getBoun.call(getDomeChild)) === null || _getDomeChild$getBoun2 === void 0 ? void 0 : _getDomeChild$getBoun2.left;
    const offsetLeft = htmlElementClientLeft - containerHtmlElementClientLeft;
    const offsetLeftSpecial = getDomeChildViewPortL - containerHtmlElementClientLeft;
    const lineAnimationLeft = offsetLeft;
    // const offsetRight = containerCountWidth - offsetLeft; // 距离右侧
    const currentElementPos = containerHtmlElementClientWidth / 2; // 中间点
    const maxDistanceRight = containerCountWidth - containerHtmlElementClientWidth;
    // 内容宽度不够 flex:1
    if (containerCountWidth > 1441) {
      if (offsetLeft - currentElementPos >= 0) {
        const toDistance = offsetLeft - currentElementPos + htmlElementClientWidth / 2;
        let val = maxDistanceRight;
        if (toDistance < maxDistanceRight) {
          val = toDistance;
          changeActionRight(maxDistanceRight, true);
        } else {
          changeActionRight(maxDistanceRight, false);
        }
        handleDome.current.style.transform = `translateX(${-val}px)`;
      } else {
        changeActionRight(maxDistanceRight, true);
        handleDome.current.style.transform = `translateX(0)`;
      }
      // 判断是否显示左侧控制台 ---- 元素可视区域距离中间点位置判断
      changeActionLeft(offsetLeft > currentElementPos);
    } else {
      setFlexChild(true);
      // offsetLeft += 20;
    }

    // 顶部浮标
    if (!hover) {
      barAnimated.current.style.width = `${htmlElementClientWidth}px`;
      barAnimated.current.style.left = `${lineAnimationLeft}px`;
    }
    getHandleDomePane.style.left = `${offsetLeftSpecial - 24}px`;
  }, [checked, childPane]);
  const towards = status => {
    checkedStatus({
      val: status ? (arr === null || arr === void 0 ? void 0 : arr.length) - 1 || 0 : 0
    });
  };
  const tabClick = (index, pane) => {
    setSvgStatus(index);
    setTempSaveParentIndex(index);
    checkedStatus({
      hover: true,
      val: index,
      pane
    });
  };
  const toTopView = (0, _react.useCallback)(() => {
    window.scrollTo(0, 0);
    setChildPane({});
    checkedStatus({
      val: tempSaveParentIndex,
      pane: null
    });
    setSvgStatus(false);
  }, [childPane, svgStatus, checked]);
  (0, _react.useEffect)(() => {
    (0, _index.windowAddEventListener)(status => {
      if (status) {
        checkedStatus({
          val: 0
        });
        // checkedStatus({ val: 2, hover: true, pane: configuration[2].pane });
      }
    });
  }, []);
  // children content click to tab
  const childClickToTab = (tabIndex, cid) => {
    let item = {};
    (0, _getDataFormCid.find)(configuration, cid, function (obj) {
      item = obj;
    });
    const index = parseInt(item.parentId || item.id || 0);
    toTopView();
    setSvgStatus(false);
    setTempSaveParentIndex(index);
    checkedStatus({
      hover: false,
      val: index,
      pane: {}
    });
    setCurrentCid(cid);
    window.childClickToTabMobile(tabIndex, cid);
  };
  if (typeof window !== 'undefined') {
    window.childClickToTab = childClickToTab;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: (0, _classnames.default)('navigation-merge-container--mo', {
      'is-fix': isFix
    })
  }, /*#__PURE__*/React.createElement(_Mobile.default, {
    setChecked: setChecked,
    setCurrentCid: setCurrentCid,
    configuration: configuration,
    isFix: isFix
  })), /*#__PURE__*/React.createElement(Container, {
    containers: children,
    currentCid: currentCid,
    domains: domains
  }, /*#__PURE__*/React.createElement("section", {
    className: (0, _classnames.default)('navigation-container__child', {
      'is-fix': isFix
    }),
    onMouseLeave: () => {
      setTempSaveParentIndex(checked);
      checkedStatus({
        val: checked,
        pane: null
      });
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: (0, _classnames.default)('navigation-merge-container', {
      'container-is-fix': isFix
    }),
    onMouseLeave: () => {
      setChildPane({});
      setSvgStatus(false);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: 'navigation-merge-container--pc'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'navigation-tabs'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'navigation-tabs-one'
  }, /*#__PURE__*/React.createElement("div", {
    onClick: towards.bind(null, false),
    className: (0, _classnames.default)('navigation-container__child__action left', {
      'bar-animation': showLeft
    })
  }, /*#__PURE__*/React.createElement(_Svg.default, null)), /*#__PURE__*/React.createElement("div", {
    className: 'navigation-ul',
    ref: handleDome,
    style: {
      transform: 'translateX(0)'
    }
  }, arr ? arr.map((item, index) => {
    const _ref8 = item || {},
      pane = _ref8.pane,
      jump = _ref8.jump,
      dataType = _ref8.dataType,
      extendProps = _ref8.extendProps;
    const _ref9 = jump || {},
      href = _ref9.href,
      hasIcon = _ref9.hasIcon;
    if (dataType === 'jump' && href) {
      return /*#__PURE__*/React.createElement("div", Object.assign({
        onMouseOver: () => {
          tabClick(index, pane);
        },
        className: (0, _classnames.default)('navigation-tabs-tab', {
          'navigation-tabs-tab-active': checked === index || tempSaveParentIndex === index,
          'navigation-tabs-tab-flex': flexChild
        }),
        key: index
      }, extendProps || {}), /*#__PURE__*/React.createElement("a", {
        className: 'div div-svg-rotate--href',
        href: href,
        target: "_blank",
        rel: "noreferrer"
      }, item.label, hasIcon ? /*#__PURE__*/React.createElement(_Jump.default, null) : null));
    }
    return /*#__PURE__*/React.createElement("div", Object.assign({
      onMouseOver: () => {
        tabClick(index, pane);
      },
      className: (0, _classnames.default)('navigation-tabs-tab', {
        'navigation-tabs-tab-active': checked === index || tempSaveParentIndex === index,
        'navigation-tabs-tab-flex': flexChild
      }),
      onClick: () => {
        if (item.cid && item.dataType === 'container') {
          setChecked(index);
          setCurrentCid(item.cid);
          setTempSaveParentIndex(index);
          checkedStatus({
            val: index,
            pane: null
          });
        }
      },
      key: index
    }, extendProps || {}), /*#__PURE__*/React.createElement("div", {
      className: (0, _classnames.default)('div', {
        'div-svg--rotate': svgStatus === index
      })
    }, /*#__PURE__*/React.createElement("span", null, " ", item.label), item.pane ? /*#__PURE__*/React.createElement(_Svg.default, null) : null));
  }) : null, /*#__PURE__*/React.createElement("div", {
    className: "navigation-bar-animated",
    ref: barAnimated
  })), /*#__PURE__*/React.createElement("div", {
    className: (0, _classnames.default)('navigation-container__child__action right', {
      'bar-animation': showRight
    }),
    onClick: towards.bind(null, true)
  }, /*#__PURE__*/React.createElement(_Svg.default, null))), /*#__PURE__*/React.createElement("div", {
    className: (0, _classnames.default)('div--hover', {
      'div--hover--show': simpleData.length || iconsDesc.length,
      'div--hover--simple': simpleData.length
    }),
    ref: handleDomePane
  }, /*#__PURE__*/React.createElement("ul", {
    className: 'simple-name'
  }, simpleData.map((item, index) => {
    const _ref0 = item || {},
      bindingNum = _ref0.bindingNum,
      extendProps = _ref0.extendProps;
    return item.href ? /*#__PURE__*/React.createElement("a", Object.assign({
      className: 'ul_li_cursor',
      key: index,
      href: item.href,
      target: "_blank",
      rel: "noreferrer"
    }, extendProps || {}), item.txt) : /*#__PURE__*/React.createElement("li", Object.assign({
      className: 'ul_li_cursor',
      key: index,
      onClick: () => {
        isFix && toTopView();
        setChecked(tempSaveParentIndex);
        setCurrentCid(item.cid);
      }
    }, extendProps || {}), item.txt);
  })), /*#__PURE__*/React.createElement("div", {
    className: 'desc-name'
  }, iconsDesc.map((item, index) => {
    const _ref1 = item || {},
      txt = _ref1.txt,
      desc = _ref1.desc,
      children = _ref1.children;
    return /*#__PURE__*/React.createElement("div", {
      className: 'li',
      key: index
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", {
      className: 'strong'
    }, txt), /*#__PURE__*/React.createElement("span", {
      className: 'span'
    }, desc)), /*#__PURE__*/React.createElement("ul", {
      className: 'column-3'
    }, children.map((items, index1) => {
      const _ref10 = items || {},
        children = _ref10.children,
        img = _ref10.img;
      const _formatVodData = (0, _formatVodData2.formatVodData)(img),
        url = _formatVodData.url,
        alt = _formatVodData.alt;
      return /*#__PURE__*/React.createElement("li", {
        className: 'column-3__child',
        key: index1
      }, /*#__PURE__*/React.createElement("strong", {
        className: 'strong'
      }, /*#__PURE__*/React.createElement("img", {
        className: 'img',
        src: url || '',
        alt: alt
      }), /*#__PURE__*/React.createElement("span", {
        className: 'title-span'
      }, items.txt)), /*#__PURE__*/React.createElement("p", {
        className: 'ul_li_cursor padding-left-32 margin-top-12'
      }, children ? children.map((item, index2) => {
        const _ref11 = item || {},
          bindingNum = _ref11.bindingNum,
          extendProps = _ref11.extendProps;
        return item.href ? /*#__PURE__*/React.createElement("a", Object.assign({
          className: 'desc-span display-block margin-top-12 hover-color-006EFF',
          href: item.href,
          target: "_blank",
          rel: "noreferrer",
          key: index2
        }, extendProps || {}), item.txt) : /*#__PURE__*/React.createElement("span", Object.assign({
          className: 'desc-span display-block margin-top-12 hover-color-006EFF',
          onClick: () => {
            isFix && toTopView();
            setChecked(tempSaveParentIndex);
            setCurrentCid(item.cid);
          },
          key: index2
        }, extendProps || {}), item.txt);
      }) : null));
    })));
  })))))))));
}
Tabs.TabPane = Tabs;

// @ts-ignore
var _default = exports.default = Tabs;
function Container(props) {
  const style = props.style,
    containers = props.containers,
    currentCid = props.currentCid,
    domains = props.domains;
  const _useState15 = (0, _react.useState)(false),
    _useState16 = (0, _slicedToArray2.default)(_useState15, 2),
    isFix = _useState16[0],
    setIsFix = _useState16[1];
  const styles = typeof style === 'object' ? style : {};
  (0, _react.useEffect)(() => {
    const fixFunc = (0, _index.throttle)(() => {
      if ((0, _index.getWinScrollY)() >= 44) {
        isFix !== true && setIsFix(true);
      } else {
        isFix !== false && setIsFix(false);
      }
    }, 50);
    fixFunc();
    window.addEventListener('scroll', fixFunc);
    return () => {
      window.removeEventListener('scroll', fixFunc);
    };
  }, [isFix]);
  const renderChild = (containers, domains) => {
    const child = containers.find(item => {
      var _item$props, _item$props$instance, _item$props$instance$;
      return ((_item$props = item.props) === null || _item$props === void 0 ? void 0 : (_item$props$instance = _item$props.instance) === null || _item$props$instance === void 0 ? void 0 : (_item$props$instance$ = _item$props$instance.data) === null || _item$props$instance$ === void 0 ? void 0 : _item$props$instance$.cid) === currentCid;
    });
    return child ? /*#__PURE__*/React.cloneElement(child, {
      domains
    }) : child;
  };
  return /*#__PURE__*/React.createElement("section", {
    className: 'navigation-container',
    style: _objectSpread(_objectSpread({}, {
      top: isFix ? '0' : '60px'
    }), styles)
  }, props.children, /*#__PURE__*/React.createElement("div", {
    className: `im-content__list im-code-edit im-content__list--show main-container`
  }, renderChild(containers, domains)));
}